import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ToastModel} from '../../typings/models/toast.model';
import {ToastMessageTypeEnum} from '../../typings/enums/toast-message-type.enum';
import {ToastDurationTypeEnum} from '../../typings/enums/toast-duration-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ToastProviderService {
  private toastsSubject = new BehaviorSubject<ToastModel[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  private nextId = 0;

  show(message: string, type: ToastMessageTypeEnum = ToastMessageTypeEnum.Info, duration: ToastDurationTypeEnum = ToastDurationTypeEnum.Medium) {
    const id = this.nextId++;
    const toast: ToastModel = {id, type, duration, message};
    this.toastsSubject.next([...this.toastsSubject.value, toast]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  dismiss(id: number) {
    this.toastsSubject.next(
      this.toastsSubject.value.filter((t) => t.id !== id)
    );
  }
}
